var Reflux = require('reflux'); 
var DappsActions = Reflux.createActions([
  "openPopUp", 
  "closePopUp",
  "onChangeSearchQuery",
]);

module.exports = DappsActions;


// WEBPACK FOOTER //
// ./src/actions/DappsActions.js